import styled from 'styled-components';
import { media } from '../Shared/theme';

const StyledIcon = styled.div`
	align-items: center;
	color: var(--label-text);
	cursor: pointer;
	display: flex;

	svg {
		transition: color 0.15s ease-in;
	}

	span {
		display: none;
		margin-left: var(--spacing-2);
		${media.condensed} {
			display: inline;
		}
	}
`;

function CourseIcon() {
	return (
		<StyledIcon>
			<svg viewBox="0 0 114 114" fill="none" width="37" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M111.307 39.92L60.224 20.657a9.133 9.133 0 00-6.448 0l-15.593 5.88S41 6.831 41.005 6.35c.014-1.398-.82-3.37-4.878-4.83C33.51.578 30.057.04 26.401.003H26.33c-6.986-.072-14.509 1.76-14.646 5.94-.171 4.27.963 8.909 1.434 13.158.238 2.146 3.558 1.777 3.32-.368l-.917-8.26c2.803 1.25 5.577 1.706 8.62 1.873V52.08h-4.003l-2.689-24.232c-.238-2.146-3.557-1.778-3.32.368l.788 7.094-12.223 4.61c-3.517 1.326-3.517 6.462 0 7.788l13.15 4.959c-3.547 2.08-2.821 8.256 1.353 9.065l-6.517 45.736C9.837 113.381 22.016 114 25.576 114c3.394 0 14.94-.515 14.256-6.238l-3.37-28.03c14.962 5.583 31.284 4.305 45.675-2.364v12.37c-2.825.741-4.916 3.316-4.916 6.37v9.75c0 .923.748 1.67 1.67 1.67h9.832a1.67 1.67 0 001.67-1.67v-9.75c0-3.054-2.09-5.629-4.916-6.37V75.715c1.635-.86 3.26-1.79 4.877-2.793.491-.305.79-.841.79-1.419V55.311l20.164-7.602c3.518-1.327 3.518-6.463 0-7.79zM87.052 96.11v8.079H80.56v-8.08a3.25 3.25 0 013.246-3.246 3.25 3.25 0 013.246 3.246zM27.48 52.08V12.388c3.037-.092 6.595-.485 9.431-1.63l-2.404 18.094-.002.015-3.1 23.213h-3.925zM37.666 6.309c-.755 2.3-8.903 2.78-11.37 2.755-2.069-.021-12.02-1.046-11.274-2.978.86-2.226 9.876-2.772 11.348-2.743 2.002.02 10.888.813 11.296 2.966zM3.34 43.814c0-.171.052-.589.532-.77l11.424-4.307 1.176 10.598-12.6-4.751a.791.791 0 01-.532-.77zm14.8 11.74c5.133 0 10.268-.052 15.4 0 1.72.017 1.587 3.1-.03 3.083H18.127c-1.656 0-1.656-3.084.013-3.084zm-4.128 52.203l6.54-45.91 3.49.035v48.721c-5.901-.334-9.778-2.058-10.03-2.846zm13.37 2.88V61.915l3.577.036 5.534 46.023c-.278.794-3.215 2.446-9.112 2.663zm82.746-66.053L78.04 56.682c-1.991.751-.767 3.86 1.178 3.125l8.585-3.236v13.997c-15.696 9.486-34.534 12.45-51.795 5.403l-1.69-14.062a4.334 4.334 0 002.485-1.34l16.973 6.4c2.038.769 4.408.774 6.449 0l9.84-3.71c2.02-.762.842-3.887-1.178-3.125l-9.841 3.71a5.795 5.795 0 01-4.092 0l-16.842-6.35c.19-2.258-1.1-4.551-3.362-5.129l2.933-22.07 17.271-6.512a5.797 5.797 0 014.091 0l21.667 8.17-24.557 10.321c-1.96.824-.63 3.888 1.295 3.08l27.806-11.688 24.872 9.378c.706.267.706 1.274 0 1.54z"
					fill="currentColor"
				/>
			</svg>
			<span>Courses</span>
		</StyledIcon>
	);
}

export default CourseIcon;
